/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ICatalogDefinitions } from 'app/shared/model/catalog-definitions.model';

export interface IMedicine {
  id?: string;
  name?: string;
  tmContains?: string | null;
  usedFor?: string;
  tmType?: string;
  addedBy?: string | null;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  manufacturer?: string | null;
  genericName?: string | null;
  unit?: string | null;
  quantity?: string | null;
  price?: string | null;
  cursor?: number;
  microSec?: number;
  country?: string;
  maximumDailyDose?: string | null;
  minimumDailyDose?: string | null;
  schedule?: string | null;
  catalog?: ICatalogDefinitions | null;
}

export const defaultValue: Readonly<IMedicine> = {
  active: false,
};
